import { render, staticRenderFns } from "./update-awards-dialog.vue?vue&type=template&id=5f71450d&"
import script from "./update-awards-dialog.vue?vue&type=script&lang=js&"
export * from "./update-awards-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports